import CorporateNavigation from "@common/Components/CorporateNavigation.vue";
import { CurrencyDenomination } from '@common/types';
import ScenarioNavigation from '@Quest/CorporateScenarios/Components/ScenarioNavigation.vue';
import { OptimizeCorporateScenarioScheduleCommandV1 } from '@Quest/CorporateScenarios/Domain/commands-core';
import CorporateScenariosQueries from '@Quest/CorporateScenarios/Domain/queries-vue-component';
import { CorporateScenarioPnlReadModel, PnlPageReadModel } from '@Quest/CorporateScenarios/Domain/readmodels';
import { ICommandBase } from '@Quest/cqrs';
import PnlViewer from '@Quest/Pnls/Components/PnlViewer.vue';
import { PnlTemplateReadModel } from '@Quest/Pnls/Domain/readmodels';
import { Component, mixins } from 'vue-facing-decorator';


@Component({ components: { CorporateNavigation, PnlViewer, ScenarioNavigation }})
export default class PnlPage extends mixins(CorporateScenariosQueries)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
    get strategyId() { return this.$route.params.strategyId; }
    get scenarioId() { return this.$route.params.scenarioId; }

    rm: PnlPageReadModel | null = null;

    get selectedPnl(): PnlTemplateReadModel | null
    {
        if (this.rm.PnlTemplates)
        {
            return (this.rm.PnlTemplateId ? this.rm.PnlTemplates.find(a => a.Id === this.rm.PnlTemplateId) : this.rm.PnlTemplates.find(a => a.IsDefault === true)) ?? null;
        }

        return null;
    }

    reloadPnl()
    {
        if (this.rm?.PnlTemplateId)
        {
            this.runCorporateScenarioPnlQueryV1(this.workspaceId, this.strategyId, this.scenarioId, this.rm.ApplyBenefitsConfidenceFactor, this.rm.PnlTemplateId, this.rm.Denomination)
            this.rm.Report = null;
        }
    }

    toggleBenefitsConfidenceFactor()
    {
        this.rm!.ApplyBenefitsConfidenceFactor = !this.rm!.ApplyBenefitsConfidenceFactor;
        this.reloadPnl();
    }

    setDenomination(d: CurrencyDenomination)
    {
        this.rm!.Denomination = d;
        this.reloadPnl();
    }

    toggleCagrVisible()
    {
        this.rm!.CagrVisible = !this.rm!.CagrVisible;
    }

    switchPnlTemplate(pnlId: string | null)
    {
        this.rm!.PnlTemplateId = pnlId;
        this.reloadPnl();
    }

    mounted()
    {
        document.title = "Enterprise Plan - P&L";
        this.runPnlPageQueryV1(this.workspaceId, this.strategyId, this.scenarioId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName == "PnlPageReadModel")
        {
            this.rm = model as PnlPageReadModel;
        }
        else if (modelName === "CorporateScenarioPnlReadModel")
        {
            const rm = model as CorporateScenarioPnlReadModel;
            this.rm.Report = rm.Report;
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (OptimizeCorporateScenarioScheduleCommandV1.matchType(cmd))
        {
            this.runPnlPageQueryV1(this.workspaceId, this.strategyId, this.scenarioId);
        }
    }
}